export const orderStatusConstants = {
    INCOMPLETE: 0,
    PENDING: 1,
    AWAITING_PAYMENT: 7,
    AWAITING_FULFILLMENT: 11,
    AWAITING_SHIPMENT: 9,
    AWAITING_PICKUP: 8,
    PARTIALLY_SHIPPED: 3,
    COMPLETED: 10,
    SHIPPED: 2,
    CANCELLED: 5,
    REFUNDED: 4,
    DECLINED: 6,
    DISPUTED: 13,
    MANUAL_VERIFICATION_REQUIRED: 12,
    PARTIALLY_REFUNDED: 14
}

export const orderStatusStringConstants = {
    INCOMPLETE: "Incomplete",
    PENDING: "Pending",
    AWAITING_PAYMENT: "Awaiting Payment",
    AWAITING_FULFILLMENT: "Awaiting Fulfillment",
    AWAITING_SHIPMENT: "Awaiting Shipment",
    AWAITING_PICKUP: "Awaiting Pickup",
    PARTIALLY_SHIPPED: "Partially Shipped",
    COMPLETED: "Completed",
    SHIPPED: "Shipped",
    CANCELLED: "Cancelled",
    REFUNDED: "Refunded",
    DECLINED: "Declined",
    DISPUTED: "Disputed",
    MANUAL_VERIFICATION_REQUIRED: "Manual Verification Required",
    PARTIALLY_REFUNDED: "Partially Refunded"
}